"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoCashLoanRequest = void 0;
var EchoCashLoanRequest = /** @class */ (function () {
    function EchoCashLoanRequest() {
    }
    return EchoCashLoanRequest;
}());
exports.EchoCashLoanRequest = EchoCashLoanRequest;
;
//# sourceMappingURL=echoCashLoan.request.js.map